let muted = false;
try { muted = window.localStorage.getItem("wowow-sound") === "off"; } catch { /* no storage */ }
export const isSoundMuted = () => muted;
export const setSoundMuted = (v) => {
  muted = v;
  try { window.localStorage.setItem("wowow-sound", v ? "off" : "on"); } catch { /* no storage */ }
};

export function playTunnelSwell(hue) {
  if (muted) return;
  try {
    const Ctx = window.AudioContext || window.webkitAudioContext;
    if (!Ctx) return;
    const ctx = new Ctx();
    const now = ctx.currentTime;
    const base = 50 + (hue / 360) * 55;

    const master = ctx.createGain();
    master.gain.setValueAtTime(0, now);
    master.gain.linearRampToValueAtTime(0.035, now + 0.35);
    master.gain.exponentialRampToValueAtTime(0.0001, now + 2.2);

    const filter = ctx.createBiquadFilter();
    filter.type = "lowpass";
    filter.frequency.setValueAtTime(180, now);
    filter.frequency.exponentialRampToValueAtTime(500, now + 0.9);
    filter.frequency.exponentialRampToValueAtTime(140, now + 2.2);

    master.connect(filter);
    filter.connect(ctx.destination);

    [base, base * 1.005, base * 1.5].forEach((f) => {
      const osc = ctx.createOscillator();
      osc.type = "sine";
      osc.frequency.value = f;
      osc.connect(master);
      osc.start(now);
      osc.stop(now + 2.4);
    });

    setTimeout(() => ctx.close(), 3000);
  } catch {
    /* audio unsupported — transition silently */
  }
}

export function playThresholdSwell() {
  if (muted) return;
  try {
    const Ctx = window.AudioContext || window.webkitAudioContext;
    if (!Ctx) return;
    const ctx = new Ctx();
    const now = ctx.currentTime;

    const master = ctx.createGain();
    master.gain.setValueAtTime(0, now);
    master.gain.linearRampToValueAtTime(0.06, now + 1.1);
    master.gain.setValueAtTime(0.06, now + 2.2);
    master.gain.exponentialRampToValueAtTime(0.0001, now + 5.5);

    const filter = ctx.createBiquadFilter();
    filter.type = "lowpass";
    filter.frequency.setValueAtTime(220, now);
    filter.frequency.exponentialRampToValueAtTime(720, now + 2.0);
    filter.frequency.exponentialRampToValueAtTime(160, now + 5.5);

    master.connect(filter);
    filter.connect(ctx.destination);

    [55, 55.6, 82.4].forEach((f) => {
      const osc = ctx.createOscillator();
      osc.type = "sine";
      osc.frequency.value = f;
      osc.connect(master);
      osc.start(now);
      osc.stop(now + 5.8);
    });

    setTimeout(() => ctx.close(), 6500);
  } catch {
    /* audio unsupported — enter silently */
  }
}
